import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Wallet, ArrowRight } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';

const reports = [
  {
    path: '/reports/new-clients',
    title: 'Новые клиенты',
    description: 'Анализ клиентской базы',
    details: 'Новые регистрации за период с группировкой по месяцам, странам и статусам',
    color: 'text-primary',
    iconBg: 'bg-primary/10 border-primary/20',
    icon: Users,
  },
  {
    path: '/reports/finances',
    title: 'Платежи и зачисления',
    description: 'Платежи и поступления',
    details: 'Отчёт по платежам и полученным зачислениям за период',
    color: 'text-green-500',
    iconBg: 'bg-green-500/10 border-green-500/20',
    icon: Wallet,
  },
];

export function ReportsPage() {
  const navigate = useNavigate();

  return (
    <div className='min-h-screen bg-background'>
      <PageHeader activeTab='reports' />

      <div className='flex flex-col items-center justify-center px-6 pb-12 pt-16'>
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className='w-full max-w-3xl'
        >
          <p className='text-xs text-muted-foreground uppercase tracking-widest mb-2 text-center'>
            Аналитика
          </p>
          <h1 className='text-2xl font-medium text-foreground tracking-wider mb-10 text-center'>
            Отчёты
          </h1>

          <div className='grid grid-cols-1 sm:grid-cols-2 gap-5'>
            {reports.map((report, i) => {
              const Icon = report.icon;
              return (
                <motion.button
                  key={report.path}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.35, delay: 0.08 * i }}
                  onClick={() => navigate(report.path)}
                  className='group flex flex-col p-7 rounded-2xl border border-border/40 bg-card text-left hover:bg-muted/20 hover:border-border/70 hover:-translate-y-0.5 transition-all cursor-pointer'
                >
                  <div
                    className={`size-11 rounded-xl border flex items-center justify-center shrink-0 mb-4 ${report.iconBg}`}
                  >
                    <Icon className={`size-5 ${report.color}`} />
                  </div>
                  <div className='flex items-start gap-3'>
                    <div className='flex-1 min-w-0'>
                      <div className='text-lg font-semibold text-foreground mb-1'>
                        {report.title}
                      </div>
                      <div className='text-sm text-muted-foreground mb-3'>{report.description}</div>
                      <div className='text-xs text-muted-foreground leading-relaxed'>
                        {report.details}
                      </div>
                    </div>
                    <ArrowRight
                      className={`size-4 mt-1 shrink-0 ${report.color} opacity-0 group-hover:opacity-100 transition-opacity`}
                    />
                  </div>
                </motion.button>
              );
            })}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
